import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorReasonEnum } from '@error/ENUM_ErrorReason';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorModel } from '../models/error.model';
import { ErrorMessageRecord } from '../records/error-message.record';

@Injectable()
export class ErrorReasonInterceptor implements HttpInterceptor {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const errorDetails = error.error.details?.[0];
        const reason = errorDetails?.reason as ErrorReasonEnum;
        const customErrorMessage = ErrorMessageRecord[reason as keyof typeof ErrorMessageRecord]?.(errorDetails?.metadata);

        const enrichedError: ErrorModel = {
          ...error,
          error: {
            ...error.error,
            reason,
            customErrorMessage,
          },
        };
        return throwError(() => enrichedError);
      }),
    );
  }
}
